var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader text-xs-center"},[_c('v-progress-circular',{attrs:{"size":50,"color":"teal","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }